const BANKS = [
  {
    code: "002",
    shortName: "BANAMEX",
    fullName:
      "Banco Nacional de México, S.A., Institución de Banca Múltiple, Grupo Financiero Banamex"
  },
  {
    code: "006",
    shortName: "BANCOMEXT",
    fullName:
      "Banco Nacional de Comercio Exterior, Sociedad Nacional de Crédito, Institución de Banca de Desarrollo"
  },
  {
    code: "009",
    shortName: "BANOBRAS",
    fullName:
      "Banco Nacional de Obras y Servicios Públicos, Sociedad Nacional de Crédito, Institución de Banca de Desarrollo"
  },
  {
    code: "012",
    shortName: "BBVA BANCOMER",
    fullName:
      "BBVA Bancomer, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA Bancomer"
  },
  {
    code: "014",
    shortName: "SANTANDER",
    fullName:
      "Banco Santander (México), S.A., Institución de Banca Múltiple, Grupo Financiero Santander"
  },
  {
    code: "019",
    shortName: "BANJERCITO",
    fullName:
      "Banco Nacional del Ejército, Fuerza Aérea y Armada, Sociedad Nacional de Crédito, Institución de Banca de Desarrollo"
  },
  {
    code: "021",
    shortName: "HSBC",
    fullName:
      "HSBC México, S.A., Institución De Banca Múltiple, Grupo Financiero HSBC"
  },
  {
    code: "030",
    shortName: "BAJIO",
    fullName: "Banco del Bajío, S.A., Institución de Banca Múltiple"
  },
  {
    code: "032",
    shortName: "IXE",
    fullName:
      "IXE Banco, S.A., Institución de Banca Múltiple, IXE Grupo Financiero"
  },
  {
    code: "036",
    shortName: "INBURSA",
    fullName:
      "Banco Inbursa, S.A., Institución de Banca Múltiple, Grupo Financiero Inbursa"
  },
  {
    code: "037",
    shortName: "INTERACCIONES",
    fullName: "Banco Interacciones, S.A., Institución de Banca Múltiple"
  },
  {
    code: "042",
    shortName: "MIFEL",
    fullName:
      "Banca Mifel, S.A., Institución de Banca Múltiple, Grupo Financiero Mifel"
  },
  {
    code: "044",
    shortName: "SCOTIABANK",
    fullName: "Scotiabank Inverlat, S.A."
  },
  {
    code: "058",
    shortName: "BANREGIO",
    fullName:
      "Banco Regional de Monterrey, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero"
  },
  {
    code: "059",
    shortName: "INVEX",
    fullName:
      "Banco Invex, S.A., Institución de Banca Múltiple, Invex Grupo Financiero"
  },
  {
    code: "060",
    shortName: "BANSI",
    fullName: "Bansi, S.A., Institución de Banca Múltiple"
  },
  {
    code: "062",
    shortName: "AFIRME",
    fullName: "Banca Afirme, S.A., Institución de Banca Múltiple"
  },
  {
    code: "072",
    shortName: "BANORTE",
    fullName:
      "Banco Mercantil del Norte, S.A., Institución de Banca Múltiple, Grupo Financiero Banorte"
  },
  {
    code: "102",
    shortName: "THE ROYAL BANK",
    fullName:
      "The Royal Bank of Scotland México, S.A., Institución de Banca Múltiple"
  },
  {
    code: "103",
    shortName: "AMERICAN EXPRESS",
    fullName:
      "American Express Bank (México), S.A., Institución de Banca Múltiple"
  },
  {
    code: "106",
    shortName: "BAMSA",
    fullName:
      "Bank of America México, S.A., Institución de Banca Múltiple, Grupo Financiero Bank of America"
  },
  {
    code: "108",
    shortName: "TOKYO",
    fullName: "Bank of Tokyo-Mitsubishi UFJ (México), S.A."
  },
  {
    code: "110",
    shortName: "JP MORGAN",
    fullName:
      "Banco J.P. Morgan, S.A., Institución de Banca Múltiple, J.P. Morgan Grupo Financiero"
  },
  {
    code: "112",
    shortName: "BMONEX",
    fullName: "Banco Monex, S.A., Institución de Banca Múltiple"
  },
  {
    code: "113",
    shortName: "VE POR MAS",
    fullName: "Banco Ve Por Mas, S.A. Institución de Banca Múltiple"
  },
  {
    code: "116",
    shortName: "ING",
    fullName:
      "ING Bank (México), S.A., Institución de Banca Múltiple, ING Grupo Financiero"
  },
  {
    code: "124",
    shortName: "CITI MEXICO",
    fullName: "Banco Citi Mexico, S.A., Institución de Banca Múltiple"
  },
  {
    code: "126",
    shortName: "CREDIT SUISSE",
    fullName:
      "Banco Credit Suisse (México), S.A. Institución de Banca Múltiple, Grupo Financiero Credit Suisse (México)"
  },
  {
    code: "127",
    shortName: "AZTECA",
    fullName: "Banco Azteca, S.A. Institución de Banca Múltiple."
  },
  {
    code: "128",
    shortName: "AUTOFIN",
    fullName: "Banco Autofin México, S.A. Institución de Banca Múltiple"
  },
  {
    code: "129",
    shortName: "BARCLAYS",
    fullName:
      "Barclays Bank México, S.A., Institución de Banca Múltiple, Grupo Financiero Barclays México"
  },
  {
    code: "130",
    shortName: "COMPARTAMOS",
    fullName: "Banco Compartamos, S.A., Institución de Banca Múltiple"
  },
  {
    code: "131",
    shortName: "BANCO FAMSA",
    fullName: "Banco Ahorro Famsa, S.A., Institución de Banca Múltiple"
  },
  {
    code: "132",
    shortName: "BMULTIVA",
    fullName:
      "Banco Multiva, S.A., Institución de Banca Múltiple, Multivalores Grupo Financiero"
  },
  {
    code: "133",
    shortName: "ACTINVER",
    fullName:
      "Banco Actinver, S.A. Institución de Banca Múltiple, Grupo Financiero Actinver"
  },
  {
    code: "134",
    shortName: "WAL-MART",
    fullName:
      "Banco Wal-Mart de México Adelante, S.A., Institución de Banca Múltiple"
  },
  {
    code: "135",
    shortName: "NAFIN",
    fullName:
      "Nacional Financiera, Sociedad Nacional de Crédito, Institución de Banca de Desarrollo"
  },
  {
    code: "136",
    shortName: "INTERBANCO",
    fullName: "Inter Banco, S.A. Institución de Banca Múltiple"
  },
  {
    code: "137",
    shortName: "BANCOPPEL",
    fullName: "BanCoppel, S.A., Institución de Banca Múltiple"
  },
  {
    code: "138",
    shortName: "ABC CAPITAL",
    fullName: "ABC Capital, S.A., Institución de Banca Múltiple"
  },
  {
    code: "139",
    shortName: "UBS BANK",
    fullName:
      "UBS Bank México, S.A., Institución de Banca Múltiple, UBS Grupo Financiero"
  },
  {
    code: "140",
    shortName: "CONSUBANCO",
    fullName: "Consubanco, S.A. Institución de Banca Múltiple"
  },
  {
    code: "141",
    shortName: "VOLKSWAGEN",
    fullName: "Volkswagen Bank, S.A., Institución de Banca Múltiple"
  },
  { code: "143",
    shortName: "CIBANCO",
    fullName: "CIBanco, S.A." },
  {
    code: "145",
    shortName: "BBASE",
    fullName: "Banco Base, S.A., Institución de Banca Múltiple"
  },
  { code: "156",
    shortName: "SABADELL",
    fullName: "Banco de Sabadell, S.A." },
  {
    code: "166",
    shortName: "BANSEFI",
    fullName:
      "Banco del Ahorro Nacional y Servicios Financieros, Sociedad Nacional de Crédito, Institución de Banca de Desarrollo"
  },
  {
    code: "167",
    shortName: "HEY BANCO",
    fullName:
      "Hey Banco, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero"
  },
  {
    code: "168",
    shortName: "HIPOTECARIA FEDERAL",
    fullName:
      "Sociedad Hipotecaria Federal, Sociedad Nacional de Crédito, Institución de Banca de Desarrollo"
  },
  {
    code: "600",
    shortName: "MONEXCB",
    fullName: "Monex Casa de Bolsa, S.A. de C.V. Monex Grupo Financiero"
  },
  {
    code: "601",
    shortName: "GBM",
    fullName: "GBM Grupo Bursátil Mexicano, S.A. de C.V. Casa de Bolsa"
  },
  { code: "602",
    shortName: "MASARI",
    fullName: "Masari Casa de Bolsa, S.A." },
  {
    code: "605",
    shortName: "VALUE",
    fullName: "Value, S.A. de C.V. Casa de Bolsa"
  },
  {
    code: "606",
    shortName: "ESTRUCTURADORES",
    fullName:
      "Estructuradores del Mercado de Valores Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "607",
    shortName: "TIBER",
    fullName: "Casa de Cambio Tiber, S.A. de C.V."
  },
  {
    code: "608",
    shortName: "VECTOR",
    fullName: "Vector Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "610",
    shortName: "B&B",
    fullName: "B y B, Casa de Cambio, S.A. de C.V."
  },
  {
    code: "614",
    shortName: "ACCCIVAL",
    fullName: "Acciones y Valores Banamex, S.A. de C.V., Casa de Bolsa"
  },
  {
    code: "615",
    shortName: "MERRILL LYNCH",
    fullName: "Merrill Lynch México, S.A. de C.V. Casa de Bolsa"
  },
  {
    code: "616",
    shortName: "FINAMEX",
    fullName: "Casa de Bolsa Finamex, S.A. de C.V."
  },
  {
    code: "617",
    shortName: "VALMEX",
    fullName: "Valores Mexicanos Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "618",
    shortName: "UNICA",
    fullName: "Unica Casa de Cambio, S.A. de C.V."
  },
  { code: "619",
    shortName: "MAPFRE",
    fullName: "MAPFRE Tepeyac, S.A." },
  {
    code: "620",
    shortName: "PROFUTURO",
    fullName: "Profuturo G.N.P., S.A. de C.V., Afore"
  },
  {
    code: "621",
    shortName: "CB ACTINVER",
    fullName: "Actinver Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "622",
    shortName: "OACTIN",
    fullName: "OPERADORA ACTINVER, S.A. DE C.V."
  },
  { code: "623",
    shortName: "SKANDIA",
    fullName: "Skandia Vida, S.A. de C.V." },
  {
    code: "626",
    shortName: "CBDEUTSCHE",
    fullName: "Deutsche Securities, S.A. de C.V. CASA DE BOLSA"
  },
  {
    code: "627",
    shortName: "ZURICH",
    fullName: "Zurich Compañía de Seguros, S.A."
  },
  {
    code: "628",
    shortName: "ZURICHVI",
    fullName: "Zurich Vida, Compañía de Seguros, S.A."
  },
  {
    code: "629",
    shortName: "SU CASITA",
    fullName: "Hipotecaria Su Casita, S.A. de C.V. SOFOM ENR"
  },
  {
    code: "630",
    shortName: "CB INTERCAM",
    fullName: "Intercam Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "631",
    shortName: "CI BOLSA",
    fullName: "CI Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "632",
    shortName: "BULLTICK CB",
    fullName: "Bulltick Casa de Bolsa, S.A., de C.V."
  },
  {
    code: "633",
    shortName: "STERLING",
    fullName: "Sterling Casa de Cambio, S.A. de C.V."
  },
  {
    code: "634",
    shortName: "FINCOMUN",
    fullName: "Fincomún, Servicios Financieros Comunitarios, S.A. de C.V."
  },
  {
    code: "636",
    shortName: "HDI SEGUROS",
    fullName: "HDI Seguros, S.A. de C.V."
  },
  {
    code: "637",
    shortName: "ORDER",
    fullName: "Order Express Casa de Cambio, S.A. de C.V."
  },
  {
    code: "638",
    shortName: "NU MEXICO",
    fullName: "NU Mexico Financiera, S.A. de C.V., Sociedad Financiera Popular"
  },
  {
    code: "640",
    shortName: "CB JPMORGAN",
    fullName:
      "J.P. Morgan Casa de Bolsa, S.A. de C.V. J.P. Morgan Grupo Financiero"
  },
  {
    code: "642",
    shortName: "REFORMA",
    fullName: "Operadora de Recursos Reforma, S.A. de C.V., S.F.P."
  },
  {
    code: "646",
    shortName: "STP",
    fullName: "Sistema de Transferencias y Pagos STP, S.A. de C.V.SOFOM ENR"
  },
  {
    code: "647",
    shortName: "TELECOMM",
    fullName: "Telecomunicaciones de México"
  },
  {
    code: "648",
    shortName: "EVERCORE",
    fullName: "Evercore Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "649",
    shortName: "SKANDIA",
    fullName: "Skandia Operadora de Fondos, S.A. de C.V."
  },
  {
    code: "651",
    shortName: "SEGMTY",
    fullName: "Seguros Monterrey New York Life, S.A de C.V."
  },
  {
    code: "652",
    shortName: "ASEA",
    fullName: "Solución Asea, S.A. de C.V., Sociedad Financiera Popular"
  },
  {
    code: "653",
    shortName: "KUSPIT",
    fullName: "Kuspit Casa de Bolsa, S.A. de C.V."
  },
  {
    code: "655",
    shortName: "SOFIEXPRESS",
    fullName: "J.P. SOFIEXPRESS, S.A. de C.V., S.F.P."
  },
  {
    code: "656",
    shortName: "UNAGRA",
    fullName: "UNAGRA, S.A. de C.V., S.F.P."
  },
  {
    code: "659",
    shortName: "OPCIONES NOROESTE",
    fullName: "OPCIONES EMPRESARIALES DEL NORESTE, S.A. DE C.V., S.F.P."
  },
  {
    code: "670",
    shortName: "LIBERTAD",
    fullName: "Libertad Servicios Financieros, S.A. De C.V."
  },
  {
    code: "706",
    shortName: "ARCUS",
    fullName: "ARCUS F.I., S.A. de C.V., Transmisor de Dinero"
  },
  { code: "901",
    shortName: "CLS",
    fullName: "Cls Bank International" },
  { code: "902",
    shortName: "INDEVAL",
    fullName: "SD. Indeval, S.A. de C.V." },
  { code: "999",
    shortName: "N/A",
    fullName: "N/A" }
] as const;

export default BANKS;
